import { DefaultTheme } from 'styled-components/macro';
import { common } from './common';

export const cipal: DefaultTheme = Object.assign(
  { ...common },
  {
    // Cafeteria palette
    palette_blue_100: '#3F51B5',
    palette_blue_5: '#CBD0EC',
    palette_blue_0: '#F7F7F7',

    // Primary palette
    palette_primary_125: '#3F51B5',
    palette_primary_100: '#3F51B5',
    palette_primary_0: '#F7F7F7'
  }
);
